'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 260px;\n  &.mobile {\n    width: inherit;\n  }\n'], ['\n  width: 260px;\n  &.mobile {\n    width: inherit;\n  }\n']);

var _immutable = require('immutable');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _InitialMessageBubble = require('../InitialMessageBubble');

var _InitialMessageBubble2 = _interopRequireDefault(_InitialMessageBubble);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var INITIAL_MESSAGE_TIMEOUT = 30000;
var initialMessageTimeout = null;

var InitialMessageBubbleWrapperDiv = _styledComponents2.default.div.withConfig({
  displayName: 'InitialMessageBubbleWrapper__InitialMessageBubbleWrapperDiv'
})(_templateObject);

var InitialMessageBubbleWrapper = function (_React$Component) {
  _inherits(InitialMessageBubbleWrapper, _React$Component);

  function InitialMessageBubbleWrapper(props) {
    _classCallCheck(this, InitialMessageBubbleWrapper);

    var _this = _possibleConstructorReturn(this, (InitialMessageBubbleWrapper.__proto__ || Object.getPrototypeOf(InitialMessageBubbleWrapper)).call(this, props));

    var hideWelcomeMessage = props.hideWelcomeMessage;

    _this.state = {
      showInitialMessage: !hideWelcomeMessage
    };

    _this.closeInitialMessage = _this.closeInitialMessage.bind(_this);
    _this.openWidget = _this.openWidget.bind(_this);
    _this.shouldRenderInitialMessageBubble = _this.shouldRenderInitialMessageBubble.bind(_this);
    return _this;
  }

  _createClass(InitialMessageBubbleWrapper, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      initialMessageTimeout = setTimeout(function () {
        _this2.setState({
          showInitialMessage: false
        });
      }, INITIAL_MESSAGE_TIMEOUT);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isOpen = nextProps.isOpen;
      var currentlyOpen = this.props.isOpen;


      if (isOpen !== currentlyOpen) {
        this.setState({
          showInitialMessage: !isOpen
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(initialMessageTimeout);
      initialMessageTimeout = null;
    }
  }, {
    key: 'openWidget',
    value: function openWidget() {
      this.setState({
        showInitialMessage: false
      });

      this.props.onUpdateOpened(true);
    }
  }, {
    key: 'closeInitialMessage',
    value: function closeInitialMessage() {
      this.setState({ showInitialMessage: false });
      this.props.onHideWelcomeMessage();
    }
  }, {
    key: 'shouldRenderInitialMessageBubble',
    value: function shouldRenderInitialMessageBubble() {
      var showInitialMessageBubble = this.props.showInitialMessageBubble;
      var showInitialMessage = this.state.showInitialMessage;

      return showInitialMessageBubble && !!showInitialMessage;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.shouldRenderInitialMessageBubble()) {
        var _props = this.props,
            chatHeadingConfig = _props.chatHeadingConfig,
            chatHeadingResponders = _props.chatHeadingResponders,
            initialMessage = _props.initialMessage,
            mobile = _props.mobile;

        return _react2.default.createElement(
          InitialMessageBubbleWrapperDiv,
          {
            ref: this.props.setInitialMessageRef,
            className: (0, _classNames2.default)('p-top-8 p-bottom-4 p-left-5', { mobile: mobile }),
            key: 'initial-message-bubble'
          },
          _react2.default.createElement(_InitialMessageBubble2.default, {
            chatHeadingConfig: chatHeadingConfig,
            initialMessage: initialMessage,
            chatHeadingResponders: chatHeadingResponders,
            mobile: mobile,
            onClick: this.openWidget,
            onClose: this.closeInitialMessage
          })
        );
      }

      return null;
    }
  }]);

  return InitialMessageBubbleWrapper;
}(_react2.default.Component);

InitialMessageBubbleWrapper.propTypes = {
  chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
  chatHeadingResponders: _react.PropTypes.instanceOf(_immutable.List),
  hideWelcomeMessage: _react.PropTypes.bool,
  initialMessage: _react.PropTypes.string,
  isOpen: _react.PropTypes.bool.isRequired,
  mobile: _react.PropTypes.bool.isRequired,
  onHideWelcomeMessage: _react.PropTypes.func,
  onUpdateOpened: _react.PropTypes.func,
  setInitialMessageRef: _react.PropTypes.func,
  showInitialMessageBubble: _react.PropTypes.bool.isRequired
};

InitialMessageBubbleWrapper.defaultProps = {
  onHideWelcomeMessage: function onHideWelcomeMessage() {},
  mobile: false,
  setInitialMessageRef: function setInitialMessageRef() {}
};

exports.default = InitialMessageBubbleWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/components/InitialMessageBubbleWrapper.js
// module id = 1188
// module chunks = 2 3